"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var units_1 = require("./units/units");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return units_1.Text; } });
//# sourceMappingURL=quantity.js.map